<template>
	<section style="padding:20px;">
		EdgeApi Test Component
		<div style="font-size:11px;">
			<pre>{{ responseData }}</pre>
		</div>
	</section>
</template>

<script>
import { defineComponent } from 'vue';
import { EdgeApi } from '@/apis/edge.api';
import { StateService } from '@/services/state.service';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';

export default defineComponent({
	name: 'EdgeApiTestComponent',
	config: {
		key: 'schreg.testEdgeApi',
		devPath: 'edgeapi-test',
		exported: false
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			eventId: '',
			eventDataResponse: {},
			responseData: {}
		};
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'ClubsStore', 'UrlStore', 'ProfileStore', 'ProspectProfileStore']);
	},
	methods: {
		completeMounting() {
			this.loadEvent().then(data => {
				this.responseData = data;
			});
		},

		loadEvent() {
			this.eventId = StateService.getQuery('eventId');

			return EdgeApi
				.getEvent(this.eventId)
				.then(response => {
					this.eventData = response.data;
					//return this.searchNearbyClub();
					return this.searchNearby(response.data.eventData.products[0].upccode);
				});
		},
		searchNearby(upcCode) {
			return EdgeApi.searchNearbyByEventId(upcCode, StateService.getQuery('eventId'));
		},
		searchNearbyClub() {
			return EdgeApi.searchNearbyByClubId();
		}
	}
});
</script>
